<div *ngIf="loading" class="waiting-spinner">
  <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
  <p>Loading...</p>
</div>
<ng-container *ngIf="!loading && profile">
  <h2>Your Profile Information</h2>
  <section class="page-section">
    <div class="mt-1 header-row">
      <div class="header-text">Personal Info</div>
    </div>
    <table class="info-table">
      <tr>
        <td><b>Name</b></td>
        <td>{{ profile | portalProfileName }}</td>
        <td class="action-cell">
          <button mat-mini-fab class="action-button" aria-label="Edit Name">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </tr>
      <tr>
        <td><b>Email</b></td>
        <td>
          {{ profile.email }}
        </td>
        <td class="action-cell">
          <button mat-mini-fab class="action-button" disabled aria-label="Edit Email">
            <mat-icon>lock</mat-icon>
          </button>
        </td>
      </tr>
      <tr>
        <td><b>Phone Number</b></td>
        <td>
          <ng-container *ngIf="profile.phoneNumber; else emptyValue">{{ profile.phoneNumber }}</ng-container>
        </td>
        <td class="action-cell">
          <button mat-mini-fab class="action-button" aria-label="Edit Phone Number">
            <mat-icon>{{ profile.phoneNumber ? 'edit' : 'add' }}</mat-icon>
          </button>
        </td>
      </tr>
      <tr>
        <td><b>Address</b></td>
        <td>
          <ng-container *ngIf="hasAddress; else emptyValue">
            <span [innerHTML]="profile | portalAddressFormat | async"></span>
          </ng-container>
        </td>
        <td class="action-cell">
          <button mat-mini-fab class="action-button" aria-label="Edit Address">
            <mat-icon>{{ hasAddress ? 'edit' : 'add' }}</mat-icon>
          </button>
        </td>
      </tr>
      <tr>
        <td><b>Job Title</b></td>
        <td>
          <ng-container *ngIf="profile.jobTitle; else emptyValue">{{ profile.jobTitle }}</ng-container>
        </td>
        <td class="action-cell">
          <button mat-mini-fab class="action-button" aria-label="Edit Job Title">
            <mat-icon>{{ profile.jobTitle ? 'edit' : 'add' }}</mat-icon>
          </button>
        </td>
      </tr>
      <tr>
        <td><b>Company</b></td>
        <td>
          <ng-container *ngIf="profile.company; else emptyValue">{{ profile.company }}</ng-container>
        </td>
        <td class="action-cell">
          <button mat-mini-fab class="action-button" aria-label="Edit Company">
            <mat-icon>{{ profile.company ? 'edit' : 'add' }}</mat-icon>
          </button>
        </td>
      </tr>
    </table>
    <ng-template #emptyValue>
      <span class="empty-value">Empty</span>
    </ng-template>
  </section>
</ng-container>
